import { render, staticRenderFns } from "./OsmOutrosDeptAdicao.vue?vue&type=template&id=7989cab6&scoped=true&lang=pug&"
import script from "./OsmOutrosDeptAdicao.vue?vue&type=script&lang=js&"
export * from "./OsmOutrosDeptAdicao.vue?vue&type=script&lang=js&"
import style0 from "./OsmOutrosDeptAdicao.vue?vue&type=style&index=0&id=7989cab6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7989cab6",
  null
  
)

export default component.exports